import { BreadcrumbBar } from "../components/breadcrumbbar.js";
import missionPageBannerFallback from "../images/missionpage-bg.jpg";


export function MissionBanner(props) {
  const bannerStyle = {
    backgroundImage: `url(${missionPageBannerFallback})`,
  };

  let statusDotClass = null;
  let statusLabel = null;
  if (props.missionStatus === "Active" || props.missionStatus === "Active Mission") {
    statusDotClass = "missionBannerStatusDot missionBannerStatusDot--active";
    statusLabel = "Active Mission";
  } else if (props.missionStatus === "Past" || props.missionStatus === "Past Mission") {
    statusDotClass = "missionBannerStatusDot missionBannerStatusDot--past";
    statusLabel = "Past Mission";
  }

  const primaryName = props.shortName || props.longName;
  const secondaryName =
    props.shortName && props.longName && props.shortName !== props.longName
      ? props.longName
      : null;

  return (
    <div className="missionBanner" style={bannerStyle}>
      <div className="missionBannerBody">
        {props.breadcrumbLevels && (
          <BreadcrumbBar levels={props.breadcrumbLevels} />
        )}
        <div className="missionBannerPrimaryName">{primaryName} Data</div>
        {secondaryName && (
          <div className="missionBannerSecondaryName">{secondaryName}</div>
        )}
        <div className="missionBannerStatusRow">
          {statusDotClass && <span className={statusDotClass}></span>}
          <span className="missionBannerStatusText">
            {statusLabel || "Missions and Observatories"}
            {props.launchDate && ` — Launch Date: ${props.launchDate}`}
          </span>
        </div>
      </div>
    </div>
  );
}
